var map = {
	"./audit.json": "./locales/de/audit.json",
	"./cdr.json": "./locales/de/cdr.json",
	"./clients.json": "./locales/de/clients.json",
	"./controlCard.json": "./locales/de/controlCard.json",
	"./csv.json": "./locales/de/csv.json",
	"./eqTypes.json": "./locales/de/eqTypes.json",
	"./equipments.json": "./locales/de/equipments.json",
	"./experiments.json": "./locales/de/experiments.json",
	"./laboratories.json": "./locales/de/laboratories.json",
	"./locations.json": "./locales/de/locations.json",
	"./lookup.json": "./locales/de/lookup.json",
	"./maintTypes.json": "./locales/de/maintTypes.json",
	"./materialTypes.json": "./locales/de/materialTypes.json",
	"./materials.json": "./locales/de/materials.json",
	"./metadata.json": "./locales/de/metadata.json",
	"./orders.json": "./locales/de/orders.json",
	"./projects.json": "./locales/de/projects.json",
	"./queryTemplate.json": "./locales/de/queryTemplate.json",
	"./reports.json": "./locales/de/reports.json",
	"./samples.json": "./locales/de/samples.json",
	"./signin.json": "./locales/de/signin.json",
	"./signup.json": "./locales/de/signup.json",
	"./specifications.json": "./locales/de/specifications.json",
	"./suppliers.json": "./locales/de/suppliers.json",
	"./tasks.json": "./locales/de/tasks.json",
	"./testPlans.json": "./locales/de/testPlans.json",
	"./tests.json": "./locales/de/tests.json",
	"./translation.json": "./locales/de/translation.json",
	"./uom.json": "./locales/de/uom.json",
	"./validation.json": "./locales/de/validation.json"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "./locales/de sync recursive \\.(json)$";